import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row, Col, FormControl } from "react-bootstrap";
import {
    faFileArrowDown,
    faArrowRight,
    faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../../utils/auth";
import { descargarOrdenPagoLegacy } from "../../helpers/legacyOrdenPagoPdf";
import { formatLegacyOrdenPagoDate, LEGACY_ORDENES_PAGO_LISTA } from "../../helpers/legacyOrdenPago";


const ListaOrdenPago2 = () => {

    const hoy = new Date().toISOString().split("T")[0];
    const [fechaSeleccionada, setFechaSeleccionada] = useState(hoy);

    const [cuitSeleccionado, setCuitSeleccionado] = useState("");
    const [ordenesPago, setOrdenesPago] = useState([]);
    const [ordenesFiltradas, setOrdenesFiltradas] = useState([]);

    const { darkMode } = useContext(DarkModeContext);
    const itemsPerPage = 20;
    const [currentPage, setCurrentPage] = useState(1);

    const fetchOrdenesPago = async (fecha) => {
        try {
            const token = getToken();

            const body = {
                Token: token,
                FechaPago: formatLegacyOrdenPagoDate(fecha),
            };

            const response = await fetch(LEGACY_ORDENES_PAGO_LISTA, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                setOrdenesPago([]);
                return;
            }

            const data = await response.json();
            setOrdenesPago(data);
            setOrdenesFiltradas(data);

        } catch (error) {
            setOrdenesPago([]);
        }
    };

    useEffect(() => {
        if (fechaSeleccionada) {
            fetchOrdenesPago(fechaSeleccionada);
        }
    }, [fechaSeleccionada]);

    useEffect(() => {
        if (cuitSeleccionado.trim() === "") {
            setOrdenesFiltradas(ordenesPago);
            return;
        }

        const filtradas = ordenesPago.filter(
            (o) =>
                o.cuit.includes(cuitSeleccionado) ||
                o.nombreDocumento
                    ?.toLowerCase()
                    .includes(cuitSeleccionado.toLowerCase())
        );

        setOrdenesFiltradas(filtradas);
    }, [cuitSeleccionado, ordenesPago]);

    const manejarFechaSeleccionada = (e) => {
        const nueva = e.target.value;
        setFechaSeleccionada(nueva);
        setCuitSeleccionado("");
        setCurrentPage(1);
        fetchOrdenesPago(nueva);
    };

    const manejarCuitSeleccionado = (e) => {
        setCuitSeleccionado(e.target.value);
        setCurrentPage(1);
    };

    const descargarOrdenPago = async (documentoId, fechaSeleccionada, nombreComercio, cuit) => {
        try {
            await descargarOrdenPagoLegacy({
                documentoId,
                fechaPago: fechaSeleccionada,
                nombreComercio,
                cuit,
            });
        } catch (error) { }
    };


    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const current = ordenesFiltradas.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(ordenesFiltradas.length / itemsPerPage);

    return (
        <div className="container mt-4">
            <Row className="my-3 align-items-center">
                <Col className="lg-6">
                    <input
                        type="date"
                        className="form-control"
                        value={fechaSeleccionada}
                        onChange={manejarFechaSeleccionada}
                        style={{
                            textAlign: "center",
                            width: "200px",
                            height: "44px",
                            background: "#B4C400",
                            color: "#FFFFFF",
                            borderRadius: "32px",
                        }}
                    />
                </Col>

                <Col className="lg-6">
                    <FormControl
                        type="text"
                        placeholder="Buscar por CUIT o Nombre"
                        value={cuitSeleccionado}
                        onChange={manejarCuitSeleccionado}
                        style={{
                            width: "200px",
                            height: "44px",
                            borderRadius: "32px",
                        }}
                    />
                </Col>
            </Row>

            {ordenesFiltradas.length > 0 ? (
                <div
                    className={
                        darkMode
                            ? "container table-responsive py-5 bg-tabla-calculadora-dark my-5"
                            : "container table-responsive py-5 bg-tabla-calculadora my-5"
                    }
                >
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nombre Documento</th>
                                <th>CUIT</th>
                                <th>Fecha Subida</th>
                                <th>Total Bruto</th>
                                <th>PDF</th>
                            </tr>
                        </thead>

                        <tbody className="text-center">
                            {current.map((orden) => (
                                <tr key={orden.documentoId}>
                                    <td>{orden.documentoId}</td>
                                    <td>{orden.nombreDocumento}</td>
                                    <td>{orden.cuit}</td>
                                    <td>
                                        {orden.fechaPago || (orden.fechaSubida ? new Date(orden.fechaSubida).toLocaleDateString() : "")}
                                    </td>
                                    <td>
                                        ${Number(orden.totalBruto || 0).toLocaleString("es-AR", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </td>

                                    <td>
                                        <Button
                                            style={{
                                                background: "#B4C400",
                                                color: "#FFF",
                                                borderRadius: "32px",
                                            }}
                                            onClick={() =>
                                                descargarOrdenPago(
                                                    orden.documentoId,
                                                    fechaSeleccionada,
                                                    orden.nombreDocumento,
                                                    orden.cuit
                                                )
                                            }
                                        >
                                            <FontAwesomeIcon icon={faFileArrowDown} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between">
                        <Button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                            style={{
                                background: "#B4C400",
                                color: "#FFF",
                                borderRadius: "32px",
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} /> Anterior
                        </Button>

                        <span>Página {currentPage} de {totalPages}</span>

                        <Button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                            style={{
                                background: "#B4C400",
                                color: "#FFF",
                                borderRadius: "32px",
                            }}
                        >
                            Siguiente <FontAwesomeIcon icon={faArrowRight} />
                        </Button>
                    </div>
                </div>
            ) : (
                <p className="text-center">No se encontraron órdenes de pago.</p>
            )}
        </div>
    );
};

export default ListaOrdenPago2;
